// extracted by mini-css-extract-plugin
module.exports = {"scoreAndIcon":"VotesDisplay_scoreAndIcon__3pSEy","votingBtnsContainer":"VotesDisplay_votingBtnsContainer__34ej9"};